// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!lato-font/css/lato-font.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/create-new-password/backgroundImage.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._3_qyO_3soGGI04pDld_YjX{border-bottom:1px solid;padding-bottom:4px;display:flex;align-items:center;margin-bottom:20px}.defaultTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.tenantTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.defaultDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}.tenantDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}.subTenantTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.subTenantDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}.defaultTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.tenantTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.defaultDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}.tenantDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}.subTenantTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#f0f0f0}.subTenantDarkTheme ._3_qyO_3soGGI04pDld_YjX{border-color:#111}._1UNHCqEkp87xHmBI0Nz9iT,._1hflDzEb_QT06OM6rIP2mQ{z-index:11;position:fixed;top:0;left:0;right:0;bottom:0;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none;animation:_3uXDYWlRzK0CFiwL5MDL32;animation-duration:350ms;animation-fill-mode:forwards;display:grid;justify-content:center;align-items:center}.defaultTheme ._1UNHCqEkp87xHmBI0Nz9iT,.defaultTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(76,76,76,.15)}.tenantTheme ._1UNHCqEkp87xHmBI0Nz9iT,.tenantTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(76,76,76,.15)}.defaultDarkTheme ._1UNHCqEkp87xHmBI0Nz9iT,.defaultDarkTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(34,34,34,.4)}.tenantDarkTheme ._1UNHCqEkp87xHmBI0Nz9iT,.tenantDarkTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(34,34,34,.4)}.subTenantTheme ._1UNHCqEkp87xHmBI0Nz9iT,.subTenantTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(76,76,76,.15)}.subTenantDarkTheme ._1UNHCqEkp87xHmBI0Nz9iT,.subTenantDarkTheme ._1hflDzEb_QT06OM6rIP2mQ{background-color:rgba(34,34,34,.4)}._1hflDzEb_QT06OM6rIP2mQ{background:center/cover no-repeat url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}._1UNHCqEkp87xHmBI0Nz9iT::-webkit-scrollbar,._1hflDzEb_QT06OM6rIP2mQ::-webkit-scrollbar{display:none}._3hAh6gvyFNUnDmgvkNKuk0{animation:_2P8IJOEyA_4pMww6-VtcFR;animation-duration:350ms;animation-fill-mode:forwards}._1uynlFFi2Okq-I8lu5YEJ_{position:relative;border-radius:3px;outline:0;padding:40px;margin:40px}.defaultTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#4c4c4c}.tenantTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#4c4c4c}.defaultDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#fff}.tenantDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#fff}.subTenantTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#4c4c4c}.subTenantDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{color:#fff}.defaultTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#fff}.tenantTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#fff}.defaultDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#222}.tenantDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#333}.subTenantTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#fff}.subTenantDarkTheme ._1uynlFFi2Okq-I8lu5YEJ_{background-color:#333}._1uynlFFi2Okq-I8lu5YEJ_:focus{outline:0}.Gu_f0PNVj85SVqLnBsmJY{z-index:1001;animation:_34a395QCrqsnwHvSFEM82c;animation-duration:350ms;animation-fill-mode:forwards}._2H1pfRu4lvMpm4HGLYGwXn{animation:_12cjH1y-XgSxEiDV3c-LP0;animation-duration:350ms;animation-fill-mode:forwards}._2j7Ic3kcFQr9mRsGbYJwhY{box-sizing:border-box;overflow:auto}.Cti-xinMnubtCoHtM7E2Z{box-sizing:border-box;overflow:auto}._2_rRyMqJ_hNd1mn-hl-bLA{position:absolute;top:12px;right:12px;display:flex}._2NebMSP1rvzooS5imjGrgM{visibility:hidden}._2J7HJDFaJVLj89-pyD0uAG{cursor:pointer;width:14px;height:14px;margin-left:20px;padding:0}@keyframes _34a395QCrqsnwHvSFEM82c{from{opacity:0;transform:translateY(-100px)}to{opacity:1;transform:translateY(0)}}@keyframes _12cjH1y-XgSxEiDV3c-LP0{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-100px)}}@keyframes _3uXDYWlRzK0CFiwL5MDL32{from{opacity:0}to{opacity:1}}@keyframes _2P8IJOEyA_4pMww6-VtcFR{from{opacity:1}to{opacity:0}}", ""]);
// Exports
exports.locals = {
	"breakpointSm": "580px",
	"breakpointMd": "768px",
	"breakpointLg": "992px",
	"breakpointXl": "1200px",
	"breakpointXxl": "1600px",
	"whiteColor": "#fff",
	"homeViewTierTypeLabelTextColor": "#cecece",
	"homeCurrentPlanRedColor": "#362f3f",
	"homeCurrentPlanBlueColor": "#1d2d36",
	"homeCurrentPlanYellowColor": "#3b3025",
	"homeCardTextColor": "#8e8e8e",
	"homeSupportBadgeTextColor": "#91b9f0",
	"homeSupportBadgeColor": "#282828",
	"homeCardVersionColor": "#8e8e8e",
	"homeCardBackgroundColor": "#282828",
	"homeCardBorderColor": "#303030",
	"homeCardNameColor": "#cecece",
	"homeIconsColor": "#91b9f0",
	"homeWireIconColor": "#403aac",
	"homeWireIconBackgroundColor": "#a8a3ff",
	"homeInfoBadgeColor": "#606060",
	"activeBackgroundColor": "#476c86",
	"activeForegroundColor": "#476c86",
	"primaryButtonBackgroundColor": "#476c86",
	"secondaryButtonForegroundColor": "#91b9f0",
	"bannerBackgroundColor": "rgba(71,108,134,.5)",
	"linkTextColor": "#5f96bc",
	"primaryButtonBackgroundHoverColor": "#5f96bc",
	"secondaryButtonBackgroundHoverColor": "#354057",
	"destructiveButtonBackgroundHoverColor": "#c12020",
	"destructiveButtonActiveBackgroundColor": "#db2828",
	"primaryButtonBackgroundActiveColor": "#222",
	"secondaryButtonBackgroundActiveColor": "#273044",
	"destructiveButtonBackgroundColor": "#a51313",
	"navigationButtonBackgroundActiveColor": "#2e384f",
	"chartNegativeColor": "#f09191",
	"chartPositiveColor": "#5fe3a1",
	"chartNeutralColor": "#cecece",
	"errorBackgroundColor": "#f46464",
	"errorBorderColor": "#f46464",
	"errorTextColor": "#f46464",
	"errorWrapperBackgroundColor": "#f2c5c5",
	"warningBackgroundColor": "#e47530",
	"warningBorderColor": "#e47530",
	"warningTextColor": "#e47530",
	"secondaryWarningBackgroundColor": "#ffc915",
	"secondaryWarningBorderColor": "#ffc915",
	"secondaryWarningTextColor": "#ffc915",
	"successBorderColor": "#5fe3a1",
	"successTextColor": "#5fe3a1",
	"pageBackgroundColor": "#222",
	"wrapperBackgroundColor": "#dfe4f2",
	"urlSectionBackgroundColor": "#dfe4f2",
	"wrapperBorderColor": "#a1b0d5",
	"modelBoxBackgroundColor": "#4c4c4c",
	"contentBackgroundColor": "#333",
	"secondaryButtonBackgroundColor": "#333",
	"textColor": "#fff",
	"textGreyColor": "#8e8e8e",
	"primaryButtonForegroundColor": "#fff",
	"bannerForegroundColor": "#4c4c4c",
	"chartOutlineColor": "#222",
	"modalOverlayColor": "rgba(34,34,34,.4)",
	"contentDividerColor": "#111",
	"contentBorderColor": "#111",
	"nestedContentBorderColor": "#cecece",
	"disabledButtonBackgroundColor": "#cecece",
	"disabledButtonForegroundColor": "#4c4c4c",
	"inputHintColor": "#cecece",
	"inputBackgroundColor": "#4c4c4c",
	"hoverBackgroundColor": "#111",
	"toggleCheckedBackgroundColor": "#91b9f0",
	"toggleUncheckedBackgroundColor": "#cecece",
	"toggleForegroundColor": "#fff",
	"mapForegroundColor": "#f0f0f0",
	"mapBackgroundColor": "#222",
	"emptyStateEllipseBackgroundColor": "#494949",
	"emptyStateBiggestCircleBackgroundColor": "#484848",
	"emptyStateSmallestCircleBackgroundColor": "#4b4b4b",
	"emptyStatePersonColor": "#4a4a52",
	"emptyStatePersonShirtColor": "#91b9f0",
	"emptyStatePersonSleeveColor": "#3b5dab",
	"emptyStateEllipseBackgroundOpacity": ".599",
	"emptyStateBiggestCircleBackgroundOpacity": ".197",
	"emptyStateSmallestCircleBackgroundOpacityFirst": ".401",
	"emptyStateSmallestCircleBackgroundOpacitySecond": ".602",
	"emptyStateSmallestCircleBackgroundOpacityThird": ".846",
	"chartFirstSet": "#708add",
	"chartSecondSet": "#dd75a0",
	"chartThirdSet": "#4a7ab6",
	"chartForthSet": "#5f96bc",
	"chartFifthSet": "#c4874a",
	"chartSixthSet": "#b63e5c",
	"chartSeventhSet": "#6c8fa9",
	"chartEighthSet": "#f3a14e",
	"chartNinthSet": "#88bbdb",
	"chartTenthSet": "#e2afc3",
	"chartEleventhSet": "#b1bfde",
	"chartTwelfthSet": "#facf96",
	"optional": "#fff",
	"disabledTextColor": "#4c4c4c",
	"colorPickerBlack": "#000",
	"iconFillColor": "#91b9f0",
	"sortIconRegularColor": "#cecece",
	"sortIconHoverColor": "#5f96bc",
	"sortIconActiveColor": "#fff",
	"calendarRangeBackgroundColor": "#91b9f0",
	"selectedTabColor": "#91b9f0",
	"basicTierBannerColor": "rgba(188,132,74,.0980392157)",
	"basicTierBannerBorderColor": "#9d6f3f",
	"premiumTierBannerColor": "rgba(107,149,184,.0980392157)",
	"premiumTierBannerBorderColor": "#6b95b8",
	"diamondTierBannerColor": "rgba(181,78,119,.0980392157)",
	"diamondTierBannerBorderColor": "#b54e77",
	"starTierBannerBorderColor": "#6f53e0",
	"chartSuccessColor": "#009e57",
	"chartFailColor": "#db3737",
	"notVerified": "#708add",
	"textFieldColor": "#111",
	"focusOutlineColorInput": "#3b5dab",
	"focusOutlineColorButton": "#d661e5",
	"tooltipTextColor": "#4c4c4c",
	"tooltipBackgroundColor": "#f0f0f0",
	"chipBackgroundColor": "#4c4c4c",
	"chipContentColor": "#fff",
	"chipUserIconColor": "#111",
	"successIconColor": "#5fe3a1",
	"errorIconColor": "#f09191",
	"localBannerBackgroundColor": "#33405f",
	"localBannerBorderColor": "#2d2d2d",
	"errorBannerBackgroundColor": "#f1a9a9",
	"localBannerTextColor": "#fff",
	"successBadgeBackgroundColor": "#006f1f",
	"successBadgeTextColor": "#e5f2e9",
	"warningBadgeBackgroundColor": "#ffda5c",
	"warningBadgeTextColor": "#715907",
	"errorBadgeBackgroundColor": "#9c2a2a",
	"errorBadgeTextColor": "#fff",
	"infoBadgeBackgroundColor": "#374f86",
	"infoBadgeTextColor": "#fff",
	"infoIconBackgroundColor": "#f0f0f0",
	"neutralBadgeBackgroundColor": "#606060",
	"neutralBadgeTextColor": "#fff",
	"strokeColor": "#364c7d",
	"textHighlightForegroundColor": "linear-gradient(0deg, rgba(255, 201, 21, 0.3) 0%, rgba(255, 201, 21, 0.3) 100%)",
	"textHighlightBackgroundColor": "#fff",
	"skeletonLoaderBackgroundColor": "#222",
	"firstLevelTierBackgroundColor": "#fff6ee",
	"secondLevelTierBackgroundColor": "#f2faff",
	"thirdLevelTierBackgroundColor": "#fff8fb",
	"fourthLevelTierBackgroundColor": "#6f53e0",
	"defaultStarColor": "#007b22",
	"userDefaultStarColor": "#cecece",
	"addOnsCheckmarkColor": "#5fe3a1",
	"warningBannerBackgroundColor": "#ffd95b",
	"warningBannerBorderColor": "#fff1c1",
	"warningBannerTextColor": "#111",
	"warningIconBackgroundColor": "#111",
	"warningIconExclamationColor": "#ffc915",
	"hoverColor": "rgba(71,108,134,.3)",
	"navigationButtonBackgroundHoverColor": "#2b303c",
	"conditionToggleButtonBackgroundColor": "#222",
	"conditionToggleButtonBorderColor": "#4c4c4c",
	"conditionTableBackgroundColor": "#222",
	"conditionTableBorderColor": "#4c4c4c",
	"conditionTableNestedBackgroundColor": "#111",
	"tabHoverColor": "#4c4c4c",
	"modularPurpleColor": "#b9a8ff",
	"modularBackgroundPurpleColor": "#41366e",
	"readyToUseSkyBlueColor": "#72bcf8",
	"readyToUseBackgroundBlueColor": "#1b364c",
	"readyToUseBorderBlueColor": "#0c62a8",
	"modularBorderPurpleColor": "#53429c",
	"descriptionTextColor": "#8e8e8e",
	"lightGreenBackgroundColor": "#e5f2e9",
	"lightBlueBackgroundColor": "#e0e5f3",
	"errorBannerColor": "#f1a9a9",
	"errorBannerTextColor": "#4c4c4c",
	"bannerIconBackgroundColor": "#db2828",
	"bannerIconColor": "#fff",
	"accordianSuccessBackgroundColor": "#183d22",
	"accordianSuccessBorderColor": "#096422",
	"accordianSuccessTextColor": "#5fe3a1",
	"homeCurrentPlanLabelTextColor": "#606060",
	"cardBorderColor": "#4c4c4c",
	"hoverCardBorderColor": "#8e8e8e",
	"defaultTheme": "defaultTheme",
	"tenantTheme": "tenantTheme",
	"defaultDarkTheme": "defaultDarkTheme",
	"tenantDarkTheme": "tenantDarkTheme",
	"subTenantTheme": "subTenantTheme",
	"subTenantDarkTheme": "subTenantDarkTheme",
	"animationDuration": "350ms",
	"title": "_3_qyO_3soGGI04pDld_YjX",
	"overlay": "_1UNHCqEkp87xHmBI0Nz9iT",
	"overlayBackgroundImage": "_1hflDzEb_QT06OM6rIP2mQ",
	"overlayFadein": "_3uXDYWlRzK0CFiwL5MDL32",
	"overlayBeforeClose": "_3hAh6gvyFNUnDmgvkNKuk0",
	"overlayFadeout": "_2P8IJOEyA_4pMww6-VtcFR",
	"modalBase": "_1uynlFFi2Okq-I8lu5YEJ_",
	"modalAfterOpen": "Gu_f0PNVj85SVqLnBsmJY",
	"openModal": "_34a395QCrqsnwHvSFEM82c",
	"modalBeforeClose": "_2H1pfRu4lvMpm4HGLYGwXn",
	"closeModal": "_12cjH1y-XgSxEiDV3c-LP0",
	"bodyScroll": "_2j7Ic3kcFQr9mRsGbYJwhY",
	"bodyStopScroll": "Cti-xinMnubtCoHtM7E2Z",
	"buttonContainer": "_2_rRyMqJ_hNd1mn-hl-bLA",
	"closeButtonContainerVisibility": "_2NebMSP1rvzooS5imjGrgM",
	"button": "_2J7HJDFaJVLj89-pyD0uAG"
};
module.exports = exports;
